export default "__VITE_ASSET__DyUwbf0I__"